import { IHuntMarker, IMarker, Popup } from '../../../types/common';

const formatDate = (value: string, full = false): string => {
  const date = new Date(value);
  const fullDate = [
    date.getFullYear(),
    ...[date.getMonth() + 1, date.getDate()].map((v) => `00${v}`.slice(-2)),
  ].join('-');
  if (!full) return fullDate;

  const fullTime = [date.getHours(), date.getMinutes()]
    .map((v) => `00${v}`.slice(-2))
    .join(':');
  return `${fullDate} ${fullTime}`;
};

const trapPopup = (marker: IMarker): Popup => `
  <div class="covey-marker-popup">
    <div class="covey-marker-popup__header">
      <div class="covey-marker-popup__label covey-marker-popup__label--green">number</div>
      <div class="covey-marker-popup__title">${marker.trapNumber}</div>
    </div>
    <div class="covey-marker-popup__body">
      <div class="covey-marker-popup__content">
        <div class="covey-marker-popup__label">LAST UPDATE DATE</div>
        <div class="covey-marker-popup__value">${formatDate(
          marker.lastUpdateDate,
        )}</div>

        <div class="covey-marker-popup__label">PREDATORS TRAPPED</div>
        <div class="covey-marker-popup__value">${marker.predatorsTrapped}</div>

        <div class="covey-marker-popup__label">SUCCESS RATE</div>
        <div class="covey-marker-popup__value">${marker.successRate}%</div>

        <div class="covey-marker-popup__label">COURSE</div>
        <div class="covey-marker-popup__value">${marker.course}</div>

        <div class="covey-marker-popup__label">COORDINATES</div>
        <div class="covey-marker-popup__value">
          ${marker.coordinates[1]}, ${marker.coordinates[0]}
        </div>

        <div class="covey-marker-popup__label">TRAP UPDATE DATES</div>
        <div class="covey-marker-popup__value">${marker.trapUpdateDates.join(
          '<br />',
        )}</div>

        <div class="covey-marker-popup__label">PLANTATION</div>
        <div class="covey-marker-popup__value">${marker.plantation}</div>
      </div>
    </div>
  </div>
`;

const huntPopup = (marker: IHuntMarker): Popup => `
  <div class="covey-marker-popup">
    <div class="covey-marker-popup__body">
      <div class="covey-marker-popup__content">
        <div class="covey-marker-popup__label">COUNT</div>
        <div class="covey-marker-popup__value">${marker.count}</div>

        <div class="covey-marker-popup__label">DOG NAME</div>
        <div class="covey-marker-popup__value">${marker.dogName}</div>

        <div class="covey-marker-popup__label">EVENT</div>
        <div class="covey-marker-popup__value">${marker.event}</div>

        <div class="covey-marker-popup__label">EVENT DATE</div>
        <div class="covey-marker-popup__value">${formatDate(
          marker.eventDate,
        )}</div>
      </div>
    </div>
  </div>
`;

const markerPopup = (marker: IMarker): Popup | undefined => {
  if (marker.type === 'trap') return trapPopup(marker);
  if (marker.type === 'hunt') return huntPopup(marker);
  return undefined;
};

export default markerPopup;
